'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dispatchACard } from '../../services/cardService';
import {
  CardDispatchData,
  CardSchema,
  TDispatchCardPayload,
} from '../../types/cards/card-types';
import { TErrorResponse } from '../../types/error/error-response';

const useDispatchACard = () => {
  const queryClient = useQueryClient();
  const { data, mutate, isPending, error, isSuccess, isError } = useMutation<
    CardDispatchData,
    TErrorResponse,
    TDispatchCardPayload,
    unknown
  >({
    mutationKey: ['create-physical-card'],
    mutationFn: ({ card_id, batch_id }) => {
      if (batch_id) {
        return dispatchACard({ batch_id });
      }
      if (card_id) {
        return dispatchACard({ card_id });
      }
      throw new Error('Either card_id or batch_id must be provided');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get-cards'] });
      queryClient.invalidateQueries({ queryKey: ['get-card-batches'] });
    },
  });

  return { data, mutate, isPending, error, isSuccess, isError };
};

export default useDispatchACard;
